module.exports = __webpack_public_path__ + "static/media/iq.a6321087.svg";